import React, { useEffect, useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';
import InsightFormatter from './FilteredInsights';
import PredictionFormatter from './PredictionsFormatter';

const AreasOfImprovementChart = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [improvementData, setImprovementData] = useState([]);
  const [insights, setInsights] = useState('');
  const [predictions, setPredictions] = useState('');

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const res = await fetch('https://18.117.231.157/api/getUserActivityImprovements', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userID: user.userID }),
        });

        const result = await res.json();
        if (result.success && result.data?.activityGoals && result.data?.activityProgress) {
          const goals = result.data.activityGoals;
          const progress = result.data.activityProgress;

          const formatted = Object.keys(goals).map(activity => {
            const goal = goals[activity] || 0;
            const achieved = progress[activity] || 0;
            const gap = goal > achieved ? goal - achieved : 0;

            return {
              activity: activity.charAt(0).toUpperCase() + activity.slice(1),
              Goal: goal,
              Achieved: achieved,
              Gap: gap,
            };
          });

          setImprovementData(formatted);

          const body = JSON.stringify({ userData: formatted });

          const insightRes = await fetch('https://18.117.231.157/api/insights', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
          });

          const insightData = await insightRes.json();
          if (insightData.success) {
            setInsights(insightData.insights);
          } else {
            console.error('Error fetching insights:', insightData.message);
          }

          const predictionRes = await fetch('https://18.117.231.157/api/predict-insights', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
          });

          const predictionData = await predictionRes.json();
          if (predictionData.success) {
            setPredictions(predictionData.prediction);
          } else {
            console.error('Error fetching predictions:', predictionData.message);
          }
        }
      } catch (err) {
        console.error('Error fetching progress:', err);
      }
    };

    fetchProgress();
  }, [user.userID]);

  return (
    <div className="logTile" style={{ padding: '1rem', marginTop: '2rem' }}>
      {/* <h2 style={{ textAlign: 'center' }}>Areas of Improvement</h2>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={improvementData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="activity" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Goal" fill="green" />
          <Bar dataKey="Achieved" fill="orange" />
          <Bar dataKey="Gap" fill="#ff4d4f" />
        </BarChart>
      </ResponsiveContainer>

      <p style={{ textAlign: 'center', marginTop: '1rem' }}>
        Activities with more red indicate areas where you're falling behind your plan.
      </p> */}

      <br />
      <div style={{ textAlign: 'center' }}>
        <InsightFormatter structuredData={insights} />
      </div>

      <br />
     
        <PredictionFormatter predictionData={predictions} />
      
    </div>
  );
};

export default AreasOfImprovementChart;